import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_ENDPOINTS, RESPONSE_STATUSES } from "@/constants/api-endpoints";

const getAuthService = () =>
  require("@/utils/axios/authenticated-user-service").default;

export const fetchUserDetailThunk = createAsyncThunk(
  "userDetails/fetchUserDetail",
  async (outletId, { rejectWithValue }) => {
    if (!outletId) return rejectWithValue("No outletId");

    try {
      const response = await getAuthService().get(
        API_ENDPOINTS.DASHBOARD.USER_DETAIL.GET_BY_ID,
        { params: { outletId } },
      );

      if (response?.status === RESPONSE_STATUSES.SUCCESS) {
        return response?.data;
      }

      return rejectWithValue("Unexpected response");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

const initialState = {
  userDetails: null,
  loading: false,
  error: null,
};

const userDetailsSlice = createSlice({
  name: "userDetails",
  initialState,
  reducers: {
    setUserDetails: (state, action) => {
      state.userDetails = action.payload;
      state.loading = false;
      state.error = null;
    },
    clearUserDetails: (state) => {
      state.userDetails = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserDetailThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserDetailThunk.fulfilled, (state, action) => {
        state.userDetails = action.payload ?? null;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchUserDetailThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setUserDetails, clearUserDetails } = userDetailsSlice.actions;

export const selectUserDetails = (state) => {
  const raw = state.userDetails?.userDetails;
  if (!raw) return null;

  // purana cached string handle karo
  if (typeof raw === "string") {
    try {
      const parsed = JSON.parse(raw);
      // agar pura response object tha to data nikalo
      return parsed?.data ?? parsed;
    } catch {
      return null;
    }
  }

  // fresh data — seedha return
  return raw;
};

export const selectUserDetailsLoading = (state) => state.userDetails?.loading;

export default userDetailsSlice.reducer;
